 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }














const makeAppURL = (appOrigin, pathname, options) => {
  const searchParams = _nullishCoalesce(_optionalChain([options, 'optionalAccess', _ => _.searchParams]), () => ( ({} )))
  const url = new URL(appOrigin)
  url.pathname = pathname
  Object.entries(searchParams).forEach((entry) => {
    url.searchParams.append(...entry)
  })
  return url.toString()
}

export default makeAppURL
